if (!customElements.get('wlsn-image-with-tabs')) {
    class WLSNImageWithTabs extends HTMLElement {
      constructor() {
        super();
  
        this.classes = {
          activeClass: 'is-active',
          visibleClass: 'is-visible',
          tabs: 'js-wlsn-image-with-tabs-tab',
          content: 'js-wlsn-image-with-tabs-text-content',
          title: 'js-wlsn-image-with-tabs-title',
          image: 'js-wlsn-image-with-tabs-image'
        };
      }
  
      connectedCallback() {
        const tabs = this.querySelectorAll(`.${this.classes.tabs}`);
  
        if (!tabs.length) return;
  
        tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            const index = tab.dataset.index;
            this.changeTab(index);
          });
        });
      }
  
      changeTab(index) {
        const { activeClass, visibleClass, tabs, title, content, image } = this.classes;
  
        this.querySelectorAll(`.${tabs}`).forEach(t =>
          t.classList.remove(activeClass)
        );
        this.querySelectorAll(`.${content}`).forEach(c =>
          c.classList.remove(visibleClass)
        );
        this.querySelectorAll(`.${title}`).forEach(t =>
          t.classList.remove(visibleClass)
        );
        this.querySelectorAll(`.${image}`).forEach(i =>
          i.classList.remove(visibleClass)
        );
  
        this.querySelector(`.${tabs}[data-index="${index}"]`)
          ?.classList.add(activeClass);
  
        this.querySelector(`.${content}[data-index="${index}"]`)
          ?.classList.add(visibleClass);
  
        this.querySelector(`.${title}[data-index="${index}"]`)
          ?.classList.add(visibleClass);
  
        this.querySelector(`.${image}[data-index="${index}"]`)
          ?.classList.add(visibleClass);
      }
  
    }
  
    customElements.define('wlsn-image-with-tabs', WLSNImageWithTabs);
  }
  